import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'
import { Fragment } from 'react'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface, PLTypedWidgetProps } from '@src/components/pl-base-widget'

import styles from './product-info.module.scss'

/**
 * PRODUCT_INFO — a v2 nested container widget. It carries no data of its own; it OWNS the layout,
 * stacking its pre-rendered child widgets (PRODUCT_PURCHASE + PRODUCT_SUMMARY + ACCORDION +
 * BRAND_COMPARISON) vertically, one after another.
 *
 * It MUST be registered even though it holds no data: the renderer only builds `renderedChildren` for
 * a resolved (registered) widget, so an unregistered PRODUCT_INFO would render a placeholder and never
 * descend to its nested PRODUCT_PURCHASE — the buy box would not render.
 */
function ProductInfoWidgetComponent(props: PLTypedWidgetProps<never>) {
  const children = props.renderedChildren ?? []
  if (children.length === 0) return null

  return (
    <div className={styles.info} data-testid="pdp-product-info">
      {children.map(child => (
        <Fragment key={child.id}>{child.node}</Fragment>
      ))}
    </div>
  )
}

export const ProductInfoWidget: PLTypedWidgetInterface<never, WidgetType.PRODUCT_INFO> = {
  id: WidgetType.PRODUCT_INFO,
  errorBoundary: PLBaseErrorBoundary,
  render: ProductInfoWidgetComponent,
}
